module.exports = __webpack_public_path__ + "img/background.8402216.jpg";